import Home from '@/components/frame/Home'

const home = {
  isShow: true,
  index: 5,
  path: '/hiddenCheck',
  component: Home,
  redirect: '/hiddenCheck/hidenList/majorHideen',
  name: 'hiddenCheck',
  isHead: true,
  meta: {
    title: '隐患排查',
    icon: 'el-icon-connection'
  },
  children: [
    {
      path: 'hidenList',
      component: () => import('@/views/hiddenCheck/index'),
      name: 'HiddenCheck',
      meta: { title: '隐患排查', close: false },
      children: [
      //检查清单维护
      {
        path: 'hideenMaintain',
        name: 'hideenMaintain',
        component: () => import('@/views/hiddenCheck/hideenMaintain/index'),
        meta: {title: '行业领域检查清单', next: '/hiddenCheck/hidenList/meshWelding', close: true}
      }, 
      {
        path: 'meshWelding',
        name: 'meshWelding',
        component: () => import('@/views/hiddenCheck/hideenMaintain/meshWelding'),
        meta: {title: '网格员检查导则', next: '/hiddenCheck/hidenList/specialList', close: true}
      }, 
      {
        path: 'specialList',
        name: 'specialList',
        component: () => import('@/views/hiddenCheck/hideenMaintain/specialList'),
        meta: {title: '专项检查清单', next: '/hiddenCheck/hidenList/dangerList', close: true}
      }, 
      {
        path: 'dangerList',
        name: 'dangerList',
        component: () => import('@/views/hiddenCheck/hideenMaintain/dangerList'),
        meta: {title: '重大隐患检查清单', next: '/hiddenCheck/hidenList/mainCheckList', close: true}
      }, 
      {
        path: 'mainCheckList',
        name: 'mainCheckList',
        component: () => import('@/views/hiddenCheck/hideenMaintain/mainCheckList'),
        meta: {title: '主体责任检查清单', next: '/hiddenCheck/hidenList/checkList', close: true}
      }, 
      //企业自查整改
      {
        path: 'checkList',
        component: () => import('@/views/hiddenCheck/checkList/index'),
        name: 'checkList',
        meta: { title: '检查清单', next: '/hiddenCheck/hidenList/hidenList', close: false}
      }, 
      {
        path: 'hidenList',
        name: 'hidenList',
        component: () => import('@/views/hiddenCheck/hidenList/index'),
        meta: {title: '隐患清单', next: '/hiddenCheck/hidenList/securityCheck', close: true}
      }, 
      {
        path: 'securityCheck',
        component: () => import('@/views/hiddenCheck/securityCheck/index'),
        name: 'securityCheck',
        meta: { title: '整改清单', next: '/hiddenCheck/hidenList/majorHideen', close: false}
      }, 
      //重大隐患管理
      {
        path: 'majorHideen',
        name: 'majorHideen',
        component: () => import('@/views/hiddenCheck/majorHideen/index'),
        meta: {title: '重大隐患管理', next: '/hiddenCheck/hidenList/supervision', close: true}
      }, 
      {
        path: 'supervision',
        name: 'supervision',
        component: () => import('@/views/hiddenCheck/supervision/index'),
        meta: {title: '监督检查管理', close: true}
      }]
    }
  ]
}

export default home



// WEBPACK FOOTER //
// ./src/router/modules/hiddenCheck.js